<template>
    <div style="overflow-x: auto">
        <table class="table b-table" v-for="(proposals, name) in item.proposals">
            <thead class="thead-dark">
                <tr>
                    <th colspan="5">{{ typePerson }}: {{ name }}</th>
                </tr>
                <tr>
                    <th class="text-center">Nº</th>
                    <th class="text-center">Data 1ª PG</th>
                    <th class="text-center">Cliente</th>
                    <th class="text-center">Parcela</th>
                    <th class="text-center">Crédito</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(proposal, key) in proposals">
                    <td class="text-center">{{ key + 1 }}</td>
                    <td class="text-center">{{ proposal.first_payment_at | moment('DD/MM/YYYY') }}</td>
                    <td>{{ proposal.client_name }}</td>
                    <td class="text-center">{{ proposal.installment }}</td>
                    <td class="text-center">{{ proposal.value | price }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="3" class="text-right">Total de Vendas</td>
                    <td></td>
                    <td class="text-center">{{ proposals.reduce((accumulator, proposal) => accumulator + parseFloat(proposal.value), 0) | price }}</td>
                </tr>
                <tr>
                    <td colspan="3" class="text-right">Limite Mínimo</td>
                    <td></td>
                    <td class="text-center">{{ item.min_value | price }}</td>
                </tr>
                <tr>
                    <td colspan="3" class="text-right">Crédito</td>
                    <td></td>
                    <td class="text-center">{{ proposals.reduce((accumulator, proposal) => accumulator + parseFloat(proposal.value), 0) - item.min_value | price }}</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="text-center">{{ item.commision_on_first_installment | price }} %</td>
                </tr>
                <tr>
                    <td colspan="3" class="text-right">Comissão</td>
                    <td></td>
                    <td class="text-center" v-if="proposals.reduce((accumulator, proposal) => accumulator + parseFloat(proposal.value), 0) - item.min_value > 0">{{ ((proposals.reduce((accumulator, proposal) => accumulator + parseFloat(proposal.value), 0) - item.min_value) * item.commision_on_first_installment) / 100 | price }}</td>
                    <td class="text-center" v-else>0,00</td>
                </tr>
                <tr>
                    <td colspan="5"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    export default {
        props: ['item', 'type'],
        computed: {
            typePerson() {
                switch (this.type) {
                    case "manager":
                        return "Gerente";
                        
                    case "after-sale":
                        return "Pós venda";

                    case "supervisor":
                        return "Supervisor";

                    default:
                        return "Vendedor"
                }
            }
        }
    }
</script>
<style scoped>
    .md-table {
        margin-bottom: 30px;
    }
</style>